export default function Loader() {
  return (
    <div className="loader">
      <img src="/images/loader.gif" alt="Loading..." />
    </div>
  );
}
